// VUE
import Vue from 'vue'
import App from './App.vue'

// ROUTER & STORE
import router from './router'
import store from './store'

// FOUNDATION
import './assets/styles/global/foundation.css'

// VUETIFY
import Vuetify from 'vuetify'
import '../node_modules/vuetify/dist/vuetify.min.css'
Vue.use(Vuetify)

// JQUERY
window.$ = require('jquery')
window.JQuery = require('jquery')

// SMOOTH SCROLL
import vueSmoothScroll from 'vue-smooth-scroll'
Vue.use(vueSmoothScroll)

// WAYPOINTS
import VueWaypoint from 'vue-waypoint'
Vue.use(VueWaypoint)

// FLASHMESSAGE
import FlashMessage from '@smartweb/vue-flash-message'
Vue.use(FlashMessage)

// COMPONENTS
import Header from './components/Header'
import Footer from './components/Footer'
import SpeedTest from './components/Speed-Test'
Vue.component('app-header', Header)
Vue.component('app-footer', Footer)
Vue.component('app-speed-test', SpeedTest)

// ROOT VUE INSTANCE
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// CONFIG
Vue.config.productionTip = false
